var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',{staticClass:"d-flex justify-content-between link"},[(_vm.showBack)?_c('img',{staticClass:"img-arrow",staticStyle:{"cursor":"pointer"},attrs:{"src":"/assets/img/arrow-left.svg"},on:{"click":function($event){return _vm.redirect()}}}):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }